import {takeLatest, call, put} from 'redux-saga/effects';
import * as ticketService from '../api/securityService';

export function* securityQuestionsQuery(action) {
    const {data} = yield call(ticketService.securityQuestionsQuery, action.values);
    yield put({type: "SECURITY_QUESTIONS_QUERRY", data});

}